// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DplN","tabsBox":"styles_tabsBox__16Jpb","createButton":"styles_createButton__1KYMB"};